export const RELOAD_MARKER_KEY = "staleFlightUpdateReloadRequested";
